// Return tracking data in format
// [ 'trackEvent', 'Category', 'Action', 'Name', 'Value' ]

// Figma comment #18
export const homeClickCtaCommencer = [
  'trackEvent',
  'Accueil',
  'Click CTA',
  'Click Passer le test',
]

// Figma comment #18
export const homeClickCtaReprendre = [
  'trackEvent',
  'Accueil',
  'Click CTA',
  'Click Reprendre mon test',
]

// Figma comment #18
export const homeClickCtaResultats = [
  'trackEvent',
  'Accueil',
  'Click CTA',
  'Click Voir les résultats',
]

// Figma comment #19
export const homeClickNewTest = [
  'trackEvent',
  'Accueil',
  'Click CTA',
  'Click Nouveau test',
]

// Figma comment #20
export const homeClickClassements = [
  'trackEvent',
  'Accueil',
  'Click Classements',
]

// Figma comment #21
export const homeClickActions = ['trackEvent', 'Accueil', 'Click Actions']

// Figma comment #22
export const homeClickOrganisations = [
  'trackEvent',
  'Accueil',
  'Click Organisations',
]

// Figma comment #23
export const homeClickEnSavoirPlus = [
  'trackEvent',
  'Accueil',
  'Click En savoir plus',
]

// Figma comment #24
export const homeClickCodeSource = [
  'trackEvent',
  'Accueil',
  'Click Code source',
]

// Figma comment #25
export const homeClickDocumentation = [
  'trackEvent',
  'Accueil',
  'Click Documentation',
]

// Figma comment #26
export const homeClickContribution = [
  'trackEvent',
  'Accueil',
  'Click Contribution',
]

export const homeClickEmoji = ['trackEvent', 'Accueil', 'Click Emoji']

export const homeMemorySuccess = ['trackEvent', 'Accueil', 'Memory Success']
